interface InsufficientBalanceModalProps {
  isOpen: boolean;
  onClose: () => void;
  balance: number;
  onAddCredits: () => void;
}

export const InsufficientBalanceModal = ({
  isOpen,
  onClose,
  balance,
  onAddCredits,
}: InsufficientBalanceModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-neutral-black rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
        <div className="text-center">
          {/* Icon */}
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
            <svg
              className="h-6 w-6 text-red-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          {/* Title */}
          <h3 className="text-lg font-semibold text-neutral-black dark:text-neutral-white mb-2">
            Insufficient Balance
          </h3>

          {/* Message */}
          <p className="text-sm text-neutral-medium-gray dark:text-neutral-medium-gray mb-6">
            Your current balance is{' '}
            <span className="font-semibold text-red-600">${balance.toFixed(2)}</span>.
            <br />
            Please add credits to continue chatting with Ella.
          </p>

          {/* Actions */}
          <div className="space-y-2">
            <button
              onClick={onAddCredits}
              className="w-full px-4 py-2 bg-brand-teal hover:bg-brand-teal-hover text-white rounded-md font-medium transition-colors"
            >
              Add Credits
            </button>
            <button
              onClick={onClose}
              className="w-full px-4 py-2 bg-neutral-light-gray dark:bg-neutral-dark-gray text-neutral-black dark:text-neutral-white rounded-md hover:bg-neutral-medium-gray dark:hover:bg-neutral-medium-gray transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
